// Centralised placeholder content + imagery for GoodLiving Strategy
export const BRAND = "GoodLiving Strategy";

export const IMAGES = {
  heroVilla:
    "https://images.unsplash.com/photo-1599777560450-e462cffc5368?crop=entropy&cs=srgb&fm=jpg&q=90&w=2400",
  heroDusk:
    "https://images.unsplash.com/photo-1707189856923-46dd41ea2bdc?crop=entropy&cs=srgb&fm=jpg&q=90&w=2000",
  coastalAerial:
    "https://images.unsplash.com/photo-1564343128896-3ffbcf9439e5?crop=entropy&cs=srgb&fm=jpg&q=90&w=2000",
  interiorWarm:
    "https://images.unsplash.com/photo-1599696848652-f0ff23bc911f?crop=entropy&cs=srgb&fm=jpg&q=90&w=1600",
  interiorEditorial:
    "https://images.unsplash.com/photo-1646987916641-1f3c8992daa2?crop=entropy&cs=srgb&fm=jpg&q=90&w=1600",
  villaAlt:
    "https://images.unsplash.com/photo-1600596542815-ffad4c1539a9?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  villaPink:
    "https://images.unsplash.com/photo-1580587771525-78b9dba3b914?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  strategy:
    "https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  meeting:
    "https://images.unsplash.com/photo-1542744173-8e7e53415bb0?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  founder:
    "https://customer-assets-gfyr7b9c.emergentagent.net/job_cross-border-capital/artifacts/9j30qcbm_NW9A4249%20%281%29.webp",
  skyline:
    "https://images.unsplash.com/photo-1541423408854-5df732b6f6d1?crop=entropy&cs=srgb&fm=jpg&q=85&w=2000",
  condoPool:
    "https://images.unsplash.com/photo-1600760380065-2fcdc9e73007?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  condoInfinity:
    "https://images.unsplash.com/photo-1619631428091-1eaa03c3bdf1?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  condoTropical:
    "https://images.unsplash.com/photo-1536625737227-92a1fc042e7e?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
};

export const DESTINATIONS = [
  "Lisbon", "Algarve", "Tulum", "Bali", "Dubai", "Marbella", "Santorini", "Lake Como", "Cape Town", "Phuket",
];

export const SERVICES = [
  {
    id: "01",
    title: "Financial Foundations",
    tagline: "Build the elite money habits required for international leverage.",
    description:
      "We engineer the disciplined cash-flow systems, credit positioning, and savings architecture that lenders and partners abroad respect. This is where the journey to a global portfolio truly begins.",
    points: [
      "Personal balance-sheet optimisation",
      "Credit & creditworthiness strategy",
      "Automated wealth-building habits",
    ],
  },
  {
    id: "02",
    title: "Creative Financing Blueprints",
    tagline: "Tailored alternative funding strategies for global markets.",
    description:
      "Most buyers assume they need full capital upfront. We design bespoke financing paths — leveraging existing assets, cross-border loans, seller financing, and strategic partnerships to unlock markets others can't reach.",
    points: [
      "Leveraging existing assets & equity",
      "Cross-border lending introductions",
      "Partnership & syndication structures",
    ],
  },
  {
    id: "03",
    title: "Acquisition Readiness",
    tagline: "Positioning you perfectly to make the cross-border purchase.",
    description:
      "From legal structuring to currency strategy and on-the-ground vetting, we ensure that when the right property appears, you move with the confidence and credibility of a seasoned international investor.",
    points: [
      "Entity & tax-aware structuring",
      "Currency & transfer strategy",
      "Due diligence & closing support",
    ],
  },
];

export const STORIES = [
  {
    name: "M. & A. Rivera",
    location: "Lisbon, Portugal",
    image: IMAGES.villaPink,
    quote:
      "We thought a home in Europe was a decade away. Within 14 months we restructured our finances and closed on a villa using a strategy we never knew existed.",
    result: "€620k villa acquired",
  },
  {
    name: "Jordan T.",
    location: "Bali, Indonesia",
    image: IMAGES.condoTropical,
    quote:
      "The creative financing blueprint let me leverage equity I was sitting on. I now own a beachfront condo that pays for itself.",
    result: "Cash-flowing rental",
  },
  {
    name: "The Okonkwo Family",
    location: "Tulum, Mexico",
    image: IMAGES.condoInfinity,
    quote:
      "GoodLiving Strategy didn't just find a property — they rebuilt our money habits. That shift is worth more than the home itself.",
    result: "Debt-free purchase",
  },
  {
    name: "Priya S.",
    location: "Algarve, Portugal",
    image: IMAGES.villaAlt,
    quote:
      "I felt locked out of international markets. Their acquisition readiness program made me a credible buyer in under a year.",
    result: "First overseas asset",
  },
];

export const STATS = [
  { value: "$48M+", label: "Cross-border acquisitions guided" },
  { value: "17", label: "Countries navigated" },
  { value: "94%", label: "Clients close within 18 months" },
  { value: "1:1", label: "Bespoke strategy, always" },
];
